import * as React from 'react'

export interface FilterItem {
  name: string
  value: string
  active?: boolean
}

export interface FilterBarProps {
  items: FilterItem[]
  allLabel: string
  paramName: string
  ariaLabel: string
  activeValue: string | undefined
  onChange: (value: string | undefined) => void
}

function buildUrl(paramName: string, value: string | undefined): string {
  return value ? '?' + paramName + '=' + encodeURIComponent(value) : '?'
}

export const FilterBar = (props: FilterBarProps) => {
  const { items, allLabel, paramName, ariaLabel, activeValue, onChange } = props

  const handlePillClick =
    (value: string | undefined) =>
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      onChange(value)
    }

  return (
    <>
      {/* Mobile: dropdown */}
      <div className="col-span-full md:hidden">
        <select
          value={activeValue ?? ''}
          onChange={(e) => {
            const val = e.target.value
            onChange(val === '' ? undefined : val)
          }}
          className="h-10 w-full border border-blue-900 bg-transparent px-3 text-sm text-blue-900 focus-visible:outline-1 focus-visible:outline-slate-300"
          aria-label={ariaLabel}
        >
          <option value="">{allLabel}</option>
          {items.map((item) => (
            <option key={item.value} value={item.value}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      {/* Desktop: filter pills */}
      <nav
        className="col-span-full hidden flex-wrap items-center gap-4 md:flex"
        aria-label={ariaLabel}
      >
        <a
          href={buildUrl(paramName, undefined)}
          onClick={handlePillClick(undefined)}
          className={
            !activeValue
              ? 'inline-flex h-8 items-center bg-blue-900 px-4 py-2 text-xs uppercase tracking-wide text-white no-underline transition-colors focus-visible:outline-1 focus-visible:outline-slate-300'
              : 'inline-flex h-8 items-center border border-blue-900 px-4 py-2 text-xs uppercase tracking-wide text-blue-900 no-underline transition-colors hover:bg-peach-300 focus-visible:outline-1 focus-visible:outline-slate-300'
          }
          aria-current={!activeValue ? 'true' : undefined}
        >
          {allLabel}
        </a>

        <span className="h-8 w-px bg-blue-900" aria-hidden="true" />

        {items.map((item) => {
          const isActive = item.value === activeValue
          return (
            <a
              key={item.value}
              href={buildUrl(paramName, item.value)}
              onClick={handlePillClick(item.value)}
              className={
                isActive
                  ? 'inline-flex h-8 items-center bg-blue-900 px-4 py-2 text-xs uppercase tracking-wide text-white no-underline transition-colors focus-visible:outline-1 focus-visible:outline-slate-300'
                  : 'inline-flex h-8 items-center border border-blue-900 px-4 py-2 text-xs uppercase tracking-wide text-blue-900 no-underline transition-colors hover:bg-peach-300 focus-visible:outline-1 focus-visible:outline-slate-300'
              }
              aria-current={isActive ? 'true' : undefined}
            >
              {item.name}
            </a>
          )
        })}
      </nav>
    </>
  )
}
